import { useState, useMemo } from 'react';

const CUISINES = ['tous', 'Italien', 'Japonais', 'Français', 'Mexicain', 'Indien', 'Chinois', 'Américain', 'Grec', 'Thaïlandais', 'Libanais', 'Espagnol', 'Autre'];

export default function FiltersBar({ filters, onChange, showStatut = true, restaurants = [] }) {
  const [open, setOpen] = useState(false);

  function update(key, val) {
    onChange({ ...filters, [key]: val });
  }

  // Liste des créateurs déduite des restaurants actuels
  const createurs = useMemo(() => {
    const map = {};
    restaurants.forEach(r => {
      if (r.added_by_profile?.username) {
        map[r.added_by_profile.username] = true;
      }
    });
    return Object.keys(map).sort();
  }, [restaurants]);

  const activeCount = [
    filters.cuisine !== 'tous' && filters.cuisine,
    filters.prix !== 'tous' && filters.prix,
    filters.noteMin && filters.noteMin !== '0',
    filters.createur && filters.createur !== 'tous',
  ].filter(Boolean).length;

  return (
    <div style={{ marginBottom: 24 }}>
      {/* Top row */}
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>

        {/* Recherche */}
        <div style={{ position: 'relative', flex: 1, minWidth: 200 }}>
          <span style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', fontSize: 15 }}>🔍</span>
          <input
            value={filters.search || ''}
            onChange={e => update('search', e.target.value)}
            placeholder="Rechercher un restaurant…"
            style={{ width: '100%', padding: '10px 12px 10px 38px', border: '1.5px solid var(--border)', borderRadius: 10, fontSize: 14, outline: 'none', background: 'var(--surface)', transition: 'border-color 0.2s' }}
            onFocus={e => e.target.style.borderColor = 'var(--brand)'}
            onBlur={e => e.target.style.borderColor = 'var(--border)'}
          />
        </div>

        {/* Statut tabs */}
        {showStatut && (
          <div style={{ display: 'flex', background: 'var(--surface-3)', borderRadius: 10, padding: 3, gap: 2 }}>
            {[{ v: 'tous', l: 'Tous' }, { v: 'teste', l: '✅ Testés' }, { v: 'tester', l: '📌 À tester' }].map(s => (
              <button key={s.v} onClick={() => update('statut', s.v)} style={{
                padding: '7px 14px', borderRadius: 8, fontSize: 13, fontWeight: 600, border: 'none', cursor: 'pointer',
                background: filters.statut === s.v ? 'var(--surface)' : 'transparent',
                color: filters.statut === s.v ? 'var(--text)' : 'var(--text-3)',
                boxShadow: filters.statut === s.v ? 'var(--shadow-sm)' : 'none',
                transition: 'all 0.2s',
              }}>{s.l}</button>
            ))}
          </div>
        )}

        {/* Bouton filtres avancés */}
        <button onClick={() => setOpen(!open)} style={{
          display: 'flex', alignItems: 'center', gap: 6,
          padding: '9px 16px', borderRadius: 10, fontSize: 14, fontWeight: 600,
          border: '1.5px solid var(--border)',
          background: open ? 'var(--brand-pale)' : 'var(--surface)',
          color: open ? 'var(--brand)' : 'var(--text-2)',
          cursor: 'pointer', transition: 'all 0.2s',
        }}>
          ⚙️ Filtres
          {activeCount > 0 && (
            <span style={{ background: 'var(--brand)', color: '#fff', width: 18, height: 18, borderRadius: '50%', fontSize: 11, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700 }}>
              {activeCount}
            </span>
          )}
        </button>
      </div>

      {/* Filtres avancés */}
      {open && (
        <div style={{ marginTop: 12, padding: '18px', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 14, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 18, animation: 'slideUp 0.2s ease' }}>

          {/* Cuisine */}
          <div>
            <label style={{ fontSize: 11, fontWeight: 700, color: 'var(--text-3)', textTransform: 'uppercase', letterSpacing: '0.07em', display: 'block', marginBottom: 8 }}>
              🍽️ Cuisine
            </label>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5 }}>
              {CUISINES.slice(0, 8).map(c => (
                <button key={c} onClick={() => update('cuisine', c)} style={{
                  padding: '4px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600,
                  background: filters.cuisine === c ? 'var(--brand)' : 'var(--surface-3)',
                  color: filters.cuisine === c ? '#fff' : 'var(--text-2)',
                  border: 'none', cursor: 'pointer', transition: 'all 0.15s',
                }}>{c === 'tous' ? 'Tous' : c}</button>
              ))}
            </div>
          </div>

          {/* Prix */}
          <div>
            <label style={{ fontSize: 11, fontWeight: 700, color: 'var(--text-3)', textTransform: 'uppercase', letterSpacing: '0.07em', display: 'block', marginBottom: 8 }}>
              💶 Prix
            </label>
            <div style={{ display: 'flex', gap: 5 }}>
              {[{ v: 'tous', l: 'Tous' }, { v: '1', l: '€' }, { v: '2', l: '€€' }, { v: '3', l: '€€€' }, { v: '4', l: '€€€€' }].map(p => (
                <button key={p.v} onClick={() => update('prix', p.v)} style={{
                  padding: '4px 10px', borderRadius: 20, fontSize: 12, fontWeight: 700,
                  background: filters.prix === p.v ? '#059669' : 'var(--surface-3)',
                  color: filters.prix === p.v ? '#fff' : 'var(--text-2)',
                  border: 'none', cursor: 'pointer', transition: 'all 0.15s',
                }}>{p.l}</button>
              ))}
            </div>
          </div>

          {/* Note min */}
          <div>
            <label style={{ fontSize: 11, fontWeight: 700, color: 'var(--text-3)', textTransform: 'uppercase', letterSpacing: '0.07em', display: 'block', marginBottom: 8 }}>
              ⭐ Note minimum
            </label>
            <div style={{ display: 'flex', gap: 5 }}>
              {[{ v: '0', l: 'Tous' }, { v: '3', l: '3★' }, { v: '4', l: '4★' }, { v: '4.5', l: '4.5★' }].map(n => (
                <button key={n.v} onClick={() => update('noteMin', n.v)} style={{
                  padding: '4px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600,
                  background: filters.noteMin === n.v ? '#F59E0B' : 'var(--surface-3)',
                  color: filters.noteMin === n.v ? '#fff' : 'var(--text-2)',
                  border: 'none', cursor: 'pointer', transition: 'all 0.15s',
                }}>{n.l}</button>
              ))}
            </div>
          </div>

          {/* Créateur */}
          {createurs.length > 0 && (
            <div>
              <label style={{ fontSize: 11, fontWeight: 700, color: 'var(--text-3)', textTransform: 'uppercase', letterSpacing: '0.07em', display: 'block', marginBottom: 8 }}>
                👤 Ajouté par
              </label>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5 }}>
                <button onClick={() => update('createur', 'tous')} style={{
                  padding: '4px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600,
                  background: (!filters.createur || filters.createur === 'tous') ? 'var(--brand)' : 'var(--surface-3)',
                  color: (!filters.createur || filters.createur === 'tous') ? '#fff' : 'var(--text-2)',
                  border: 'none', cursor: 'pointer', transition: 'all 0.15s',
                }}>Tous</button>
                {createurs.map(c => (
                  <button key={c} onClick={() => update('createur', c)} style={{
                    display: 'flex', alignItems: 'center', gap: 5,
                    padding: '4px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600,
                    background: filters.createur === c ? 'var(--brand)' : 'var(--surface-3)',
                    color: filters.createur === c ? '#fff' : 'var(--text-2)',
                    border: 'none', cursor: 'pointer', transition: 'all 0.15s',
                  }}>
                    <span style={{ width: 16, height: 16, borderRadius: '50%', background: filters.createur === c ? 'rgba(255,255,255,0.3)' : 'var(--brand)', color: '#fff', fontSize: 9, fontWeight: 700, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                      {c[0].toUpperCase()}
                    </span>
                    {c}
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* Reset */}
          <div style={{ display: 'flex', alignItems: 'flex-end' }}>
            <button onClick={() => onChange({ statut: 'tous', cuisine: 'tous', prix: 'tous', noteMin: '0', search: '', createur: 'tous' })}
              style={{ fontSize: 13, color: 'var(--brand)', fontWeight: 600, background: 'none', border: 'none', cursor: 'pointer' }}>
              ↺ Réinitialiser
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
